import { Box, Text, TextButton } from '@wix/design-system';
import { Refresh } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { BngDomainSuggestionsDataHooks } from './dataHooks';
const BngPageLoadError = _ref => {
  let onRetry = _ref.onRetry,
    message = _ref.message;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t,
    Trans = _DomainSearchGateModu.Trans;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    verticalAlign: "middle",
    textAlign: "center",
    gap: "SP4",
    width: "100%",
    minHeight: "100vh",
    boxSizing: "border-box",
    padding: "SP4",
    dataHook: BngDomainSuggestionsDataHooks.pageLoadError
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, t('domain_search_gate.bng_results.error.full_page.connection.title')), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: message,
    components: [/*#__PURE__*/React.createElement("br", null)]
  })), /*#__PURE__*/React.createElement(TextButton, {
    prefixIcon: /*#__PURE__*/React.createElement(Refresh, null),
    onClick: onRetry
  }, t('domain_search_gate.bng_results.error.full_page.try_again.cta')));
};
export default BngPageLoadError;
//# sourceMappingURL=BngPageLoadError.js.map